import { render } from "./row.vue?vue&type=template&id=519cf6d1&scoped=true"
import script from "./row.vue?vue&type=script&lang=js"
export * from "./row.vue?vue&type=script&lang=js"

import "./row.vue?vue&type=style&index=0&id=519cf6d1&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-519cf6d1"]])

export default __exports__